import { Navigate } from 'react-router-dom';

import { ROUTES } from '../../constants';
import { HomePage } from '../../pages/home';
import { useAppSelector } from '../../store/hooks';
import { isAppHost, isMarketingHost } from '../../utils/siteHost';

/** `/` on marketing hosts = landing; on app host = enter the product. */
export function RootHomeRoute() {
  const { isAuthenticated } = useAppSelector(state => state.auth);

  if (isMarketingHost()) {
    return <HomePage />;
  }

  if (isAppHost()) {
    return (
      <Navigate
        to={isAuthenticated ? ROUTES.DASHBOARD : ROUTES.LOGIN}
        replace
      />
    );
  }

  return <HomePage />;
}
